import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ResolveHostResolver implements Resolve<any> {

  constructor() { }

  resolve() {
    if (window.location.origin.indexOf('cp.sync.com') > -1) {
      const curUrl = window.location.href,
        newUrl = curUrl.replace(
          window.location.protocol + '//' + window.location.hostname + '/',
          environment.linkhost
        );
      window.location.href = newUrl;
      return;
    }
  }
}
